(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["astra-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.astra-hero .astra-fade').forEach(function (el) {
      requestAnimationFrame(function () {
        el.classList.add('is-visible');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["astra-shop-the-look"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('astra-shop-the-look')) {
    customElements.define('astra-shop-the-look', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.hotspots = [...this.querySelectorAll('[data-astra-hotspot]')];
        this.hotspots.forEach(hotspot => {
          const toggle = hotspot.querySelector('[data-astra-hotspot-toggle]');
          toggle.addEventListener('click', () => {
            if (hotspot.hoverOpened) { hotspot.hoverOpened = false; return; }
            this.setOpen(hotspot, !hotspot.classList.contains('is-open'));
          }, options);
          hotspot.addEventListener('pointerenter', event => {
            clearTimeout(hotspot.closeTimer);
            if (event.pointerType === 'mouse' && !hotspot.classList.contains('is-open')) { this.setOpen(hotspot, true); hotspot.hoverOpened = true; }
          }, options);
          hotspot.addEventListener('pointerleave', event => { if (event.pointerType === 'mouse' && !hotspot.contains(document.activeElement)) hotspot.closeTimer = setTimeout(() => this.setOpen(hotspot, false), 180); }, options);
          hotspot.addEventListener('focusout', event => { if (!hotspot.contains(event.relatedTarget)) this.setOpen(hotspot, false); }, options);
        });
        document.addEventListener('click', event => { if (!this.hotspots.some(hotspot => hotspot.contains(event.target))) this.closeAll(); }, options);
        this.addEventListener('keydown', event => {
          if (event.key !== 'Escape') return;
          const hotspot = event.target.closest('[data-astra-hotspot]');
          this.closeAll(); hotspot?.querySelector('[data-astra-hotspot-toggle]')?.focus();
        }, options);
        window.addEventListener('resize', () => this.hotspots.filter(h => h.classList.contains('is-open')).forEach(h => this.position(h)), options);
        document.addEventListener('shopify:block:select', event => {
          const hotspot = event.target.closest('[data-astra-hotspot]');
          if (hotspot && this.contains(hotspot)) this.setOpen(hotspot, true);
        }, options);
      }
      closeAll(except) { this.hotspots.forEach(hotspot => { if (hotspot !== except) this.setOpen(hotspot, false); }); }
      setOpen(hotspot, open) {
        clearTimeout(hotspot.closeTimer);
        if (!open) hotspot.hoverOpened = false;
        if (open) this.closeAll(hotspot);
        hotspot.classList.toggle('is-open', open);
        hotspot.querySelector('[data-astra-hotspot-toggle]').setAttribute('aria-expanded', String(open));
        hotspot.querySelector('[data-astra-hotspot-card]').hidden = !open;
        if (open) this.position(hotspot);
      }
      position(hotspot) {
        const card = hotspot.querySelector('[data-astra-hotspot-card]');
        const anchor = hotspot.getBoundingClientRect();
        const width = card.getBoundingClientRect().width;
        const left = Math.max(16, Math.min(window.innerWidth - width - 16, anchor.left + anchor.width / 2 - width / 2));
        card.style.setProperty('--card-left', (left - anchor.left) + 'px');
        card.toggleAttribute('data-below', anchor.top < card.offsetHeight + 24);
      }
      disconnectedCallback() { this.controller?.abort(); this.hotspots?.forEach(h => clearTimeout(h.closeTimer)); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function () {
    var openBtn = document.querySelector('[data-astra-filter-open]');
    var drawer = document.querySelector('[data-astra-filter-drawer]');
    var overlay = document.querySelector('[data-astra-filter-overlay]');
    var closeBtns = document.querySelectorAll('[data-astra-filter-close]');
    var sortSelect = document.querySelector('[data-astra-sort-select]');
    var form = document.querySelector('.astra-collection__layout');
    var lastFocus = null;

    function isDesktop() {
      return window.matchMedia('(min-width: 990px)').matches;
    }

    function getFocusable(container) {
      return Array.prototype.slice.call(
        container.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])'
        )
      );
    }

    function closeDrawer() {
      if (!drawer || isDesktop()) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('hidden', '');
      if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
      if (overlay) {
        overlay.classList.remove('is-visible');
        overlay.setAttribute('hidden', '');
      }
      document.documentElement.classList.remove('astra-scroll-lock');
      document.documentElement.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
      lastFocus = null;
    }

    function openDrawer() {
      if (!drawer || isDesktop()) return;
      lastFocus = document.activeElement;
      drawer.classList.add('is-open');
      drawer.removeAttribute('hidden');
      if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
      if (overlay) {
        overlay.classList.add('is-visible');
        overlay.removeAttribute('hidden');
      }
      document.documentElement.classList.add('astra-scroll-lock');
      document.documentElement.style.overflow = 'hidden';
      var focusable = getFocusable(drawer);
      if (focusable.length) focusable[0].focus();
    }

    if (openBtn && drawer) {
      openBtn.addEventListener('click', openDrawer);
      closeBtns.forEach(function (btn) {
        btn.addEventListener('click', closeDrawer);
      });
      if (overlay) overlay.addEventListener('click', closeDrawer);
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') closeDrawer();
        if (event.key !== 'Tab' || !drawer.classList.contains('is-open') || isDesktop()) return;
        var focusable = getFocusable(drawer);
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });
      window.addEventListener('resize', function () {
        if (isDesktop()) {
          drawer.classList.remove('is-open');
          drawer.removeAttribute('hidden');
          if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
          if (overlay) {
            overlay.classList.remove('is-visible');
            overlay.setAttribute('hidden', '');
          }
          document.documentElement.classList.remove('astra-scroll-lock');
          document.documentElement.style.overflow = '';
        } else if (!drawer.classList.contains('is-open')) {
          drawer.setAttribute('hidden', '');
        }
      });
      if (isDesktop()) drawer.removeAttribute('hidden');
    }

    if (sortSelect && form) {
      sortSelect.addEventListener('change', function () {
        var hidden = form.querySelector('input[name="sort_by"][type="hidden"]');
        if (hidden) hidden.value = sortSelect.value;
        form.submit();
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (function () {
    var footer = document.querySelector('.astra-footer');
    if (!footer || footer.dataset.astraBound === '1') return;
    footer.dataset.astraBound = '1';

    var mq = window.matchMedia('(min-width: 768px)');
    var accordions = footer.querySelectorAll('.astra-footer__accordion');

    function syncAccordions() {
      accordions.forEach(function (el) {
        if (mq.matches) el.setAttribute('open', '');
      });
    }
    syncAccordions();
    if (mq.addEventListener) mq.addEventListener('change', syncAccordions);
    else if (mq.addListener) mq.addListener(syncAccordions);

    footer.querySelectorAll('[data-astra-locale-select]').forEach(function (select) {
      select.addEventListener('change', function () {
        if (select.form) select.form.submit();
      });
    });

    var success = footer.querySelector('.astra-footer__newsletter-success');
    if (success && success.focus) success.focus();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var header = document.querySelector('[data-astra-header]');
    var overlay = document.getElementById('AstraOverlay');
    var megaBackdrop = document.querySelector('[data-astra-mega-backdrop]');
    var openButtons = document.querySelectorAll('[data-astra-drawer-open]');
    var drawers = document.querySelectorAll('[data-astra-drawer]');
    var openDrawerEl = null;
    var lastFocus = null;
    var megaOpenTimer = null;
    var megaCloseTimer = null;
    var activeMega = null;

    function getFocusable(container) {
      return Array.prototype.slice.call(
        container.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )
      ).filter(function (el) {
        return !el.hasAttribute('hidden') && el.offsetParent !== null;
      });
    }

    function setMegaBackdrop(show) {
      if (!megaBackdrop) return;
      if (show) {
        megaBackdrop.classList.add('is-visible');
        megaBackdrop.removeAttribute('hidden');
      } else {
        megaBackdrop.classList.remove('is-visible');
        megaBackdrop.setAttribute('hidden', '');
      }
    }

    function closeMega() {
      document.querySelectorAll('[data-mega-trigger].is-open').forEach(function (item) {
        item.classList.remove('is-open');
        var link = item.querySelector('.astra-header__nav-link');
        if (link) link.setAttribute('aria-expanded', 'false');
      });
      activeMega = null;
      setMegaBackdrop(false);
    }

    function openMega(item) {
      if (activeMega === item) return;
      closeMega();
      item.classList.add('is-open');
      var link = item.querySelector('.astra-header__nav-link');
      if (link) link.setAttribute('aria-expanded', 'true');
      activeMega = item;
      setMegaBackdrop(true);
    }

    function closeAllDrawers() {
      drawers.forEach(function (drawer) {
        drawer.classList.remove('is-open');
        drawer.setAttribute('hidden', '');
      });
      openButtons.forEach(function (btn) {
        btn.setAttribute('aria-expanded', 'false');
      });
      if (overlay) {
        overlay.classList.remove('is-visible');
        overlay.setAttribute('hidden', '');
      }
      document.documentElement.classList.remove('astra-scroll-lock');
      document.documentElement.style.overflow = '';
      openDrawerEl = null;
      if (lastFocus && typeof lastFocus.focus === 'function') {
        lastFocus.focus();
      }
      lastFocus = null;
    }

    function openDrawer(id, trigger) {
      var drawer = document.getElementById(id);
      if (!drawer) return;
      closeMega();
      closeAllDrawers();
      lastFocus = trigger || document.activeElement;
      drawer.classList.add('is-open');
      drawer.removeAttribute('hidden');
      openDrawerEl = drawer;
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      if (overlay) {
        overlay.classList.add('is-visible');
        overlay.removeAttribute('hidden');
      }
      document.documentElement.classList.add('astra-scroll-lock');
      document.documentElement.style.overflow = 'hidden';
      if (id === 'search-drawer') {
        var searchInput = drawer.querySelector('[data-astra-predictive-input]');
        if (searchInput) {
          window.setTimeout(function () {
            searchInput.focus();
          }, 30);
          return;
        }
      }
      var focusable = getFocusable(drawer);
      if (focusable.length) focusable[0].focus();
    }

    openButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        openDrawer(btn.getAttribute('data-astra-drawer-open'), btn);
      });
    });

    document.querySelectorAll('[data-astra-drawer-close]').forEach(function (btn) {
      btn.addEventListener('click', closeAllDrawers);
    });

    if (overlay) {
      overlay.addEventListener('click', closeAllDrawers);
    }

    if (megaBackdrop) {
      megaBackdrop.addEventListener('click', closeMega);
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        if (openDrawerEl) closeAllDrawers();
        else closeMega();
        return;
      }

      if (event.key !== 'Tab' || !openDrawerEl) return;
      var focusable = getFocusable(openDrawerEl);
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    document.querySelectorAll('[data-mega-trigger]').forEach(function (item) {
      var link = item.querySelector('.astra-header__nav-link');

      item.addEventListener('mouseenter', function () {
        window.clearTimeout(megaCloseTimer);
        megaOpenTimer = window.setTimeout(function () {
          openMega(item);
        }, 90);
      });

      item.addEventListener('mouseleave', function () {
        window.clearTimeout(megaOpenTimer);
        megaCloseTimer = window.setTimeout(function () {
          if (activeMega === item) closeMega();
        }, 180);
      });

      item.addEventListener('focusin', function () {
        window.clearTimeout(megaCloseTimer);
        openMega(item);
      });

      item.addEventListener('focusout', function (event) {
        if (!item.contains(event.relatedTarget)) {
          megaCloseTimer = window.setTimeout(function () {
            if (activeMega === item) closeMega();
          }, 120);
        }
      });

      if (link) {
        link.addEventListener('click', function (event) {
          if (window.matchMedia('(hover: hover)').matches && item.querySelector('[data-mega-panel]')) {
            if (!item.classList.contains('is-open')) {
              event.preventDefault();
              openMega(item);
            }
          }
        });
      }
    });

    if (header) {
      var onScroll = function () {
        header.classList.toggle('is-scrolled', window.scrollY > 8);
      };
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });

      if (header.classList.contains('astra-header--transparent')) {
        var syncTransparentOffset = function () {
          var height = header.offsetHeight || 0;
          document.documentElement.style.setProperty('--astra-header-height', height + 'px');
        };
        syncTransparentOffset();
        window.addEventListener('resize', syncTransparentOffset);
      }
    }

    /* Announcement dismiss + rotate */
    (function initAnnouncement() {
      var bar = document.querySelector('[data-astra-announcement]');
      if (!bar) return;
      var storageKey = 'astra-announcement-dismissed';
      if (bar.getAttribute('data-dismissible') === 'true' && window.localStorage.getItem(storageKey) === '1') {
        bar.setAttribute('hidden', '');
        return;
      }
      var dismissBtn = bar.querySelector('[data-astra-announcement-dismiss]');
      if (dismissBtn) {
        dismissBtn.addEventListener('click', function () {
          bar.setAttribute('hidden', '');
          try {
            window.localStorage.setItem(storageKey, '1');
          } catch (error) {}
        });
      }
      var messages = bar.querySelectorAll('[data-announcement-msg]');
      if (bar.getAttribute('data-rotate') === 'true' && messages.length > 1) {
        var index = 0;
        var ms = Number(bar.getAttribute('data-rotate-ms') || 5000);
        window.setInterval(function () {
          messages[index].classList.remove('is-active');
          index = (index + 1) % messages.length;
          messages[index].classList.add('is-active');
        }, ms);
      }
    })();

    /* Predictive search */
    (function initPredictive() {
      var input = document.querySelector('[data-astra-predictive-input]');
      var results = document.querySelector('[data-astra-predictive-results]');
      if (!input || !results) return;
      var idleHtml = results.innerHTML;
      var timer = null;
      var activeIndex = -1;
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var loadingLabel = results.getAttribute('data-loading-label') || 'Searching…';

      function getOptions() {
        return Array.prototype.slice.call(results.querySelectorAll('[role="option"]'));
      }

      function clearActive() {
        getOptions().forEach(function (opt) {
          opt.classList.remove('is-active');
          opt.setAttribute('aria-selected', 'false');
        });
        input.removeAttribute('aria-activedescendant');
        activeIndex = -1;
      }

      function setActive(index) {
        var options = getOptions();
        if (!options.length) return;
        clearActive();
        activeIndex = (index + options.length) % options.length;
        var opt = options[activeIndex];
        opt.classList.add('is-active');
        opt.setAttribute('aria-selected', 'true');
        if (opt.id) input.setAttribute('aria-activedescendant', opt.id);
        opt.scrollIntoView({ block: 'nearest' });
      }

      function renderIdle() {
        results.innerHTML = idleHtml;
        input.setAttribute('aria-expanded', 'false');
        clearActive();
      }

      function renderLoading() {
        results.innerHTML = '<p class="astra-predictive-loading" role="status">' + loadingLabel + '</p>';
        input.setAttribute('aria-expanded', 'true');
        clearActive();
      }

      function search(term) {
        if (!term || term.trim().length < 2) {
          renderIdle();
          return;
        }
        renderLoading();
        var url =
          root +
          'search/suggest?q=' +
          encodeURIComponent(term) +
          '&resources[type]=product&resources[limit]=6&section_id=predictive-search';
        fetch(url)
          .then(function (response) {
            return response.text();
          })
          .then(function (text) {
            var doc = new DOMParser().parseFromString(text, 'text/html');
            var section =
              doc.querySelector('#shopify-section-predictive-search') ||
              doc.querySelector('.astra-predictive-results');
            results.innerHTML = section ? section.innerHTML : '';
            input.setAttribute('aria-expanded', 'true');
            clearActive();
          })
          .catch(function () {
            renderIdle();
          });
      }

      input.addEventListener('input', function () {
        window.clearTimeout(timer);
        timer = window.setTimeout(function () {
          search(input.value);
        }, 280);
      });

      input.addEventListener('keydown', function (event) {
        var options = getOptions();
        if (event.key === 'Escape') {
          event.preventDefault();
          renderIdle();
          input.value = '';
          return;
        }
        if (!options.length) return;
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          setActive(activeIndex + 1);
        } else if (event.key === 'ArrowUp') {
          event.preventDefault();
          setActive(activeIndex - 1);
        } else if (event.key === 'Enter' && activeIndex >= 0) {
          var link = options[activeIndex].querySelector('a');
          if (link) {
            event.preventDefault();
            window.location.href = link.href;
          }
        }
      });
    })();

    window.AstraTheme = window.AstraTheme || {};
    window.AstraTheme.syncCartCount = function (count) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = String(count);
        if (count > 0) el.removeAttribute('hidden');
        else el.setAttribute('hidden', '');
      });
      document.querySelectorAll('[data-cart-drawer-title]').forEach(function (el) {
        var title = el.getAttribute('data-cart-title') || 'Cart';
        el.textContent = title + ' (' + count + ')';
      });
    };
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-details"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('astra-product-details')) {
    customElements.define(
      'astra-product-details',
      class extends HTMLElement {
        connectedCallback() {
          this.controller = new AbortController();
          const options = { signal: this.controller.signal };
          this.hydrateFromDescription();
          this.panels = [...this.querySelectorAll('[data-detail-panel]')];
          this.tabs = [...this.querySelectorAll('[data-detail-tab]')];
          this.media = window.matchMedia('(min-width: 990px)');
          this.active = this.panels.find((panel) => panel.dataset.hasContent === 'true')?.dataset.detailPanel;
          this.tabs.forEach((tab) => {
            tab.addEventListener(
              'click',
              () => {
                this.active = tab.dataset.detailTab;
                this.render();
              },
              options
            );
            tab.addEventListener(
              'keydown',
              (event) => {
                if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
                const tabs = this.tabs.filter((item) => !item.hidden);
                const index = tabs.indexOf(tab);
                const next =
                  event.key === 'Home'
                    ? 0
                    : event.key === 'End'
                      ? tabs.length - 1
                      : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
                event.preventDefault();
                this.active = tabs[next].dataset.detailTab;
                this.render();
                tabs[next].focus();
              },
              options
            );
          });
          this.media.addEventListener('change', () => this.render(), options);
          document.addEventListener(
            'shopify:block:select',
            (event) => {
              const panel = event.target.closest('[data-detail-panel]');
              if (!panel || !this.contains(panel)) return;
              this.active = panel.dataset.detailPanel;
              this.render();
              const details = panel.querySelector('details');
              if (details) details.open = true;
            },
            options
          );
          this.render();
        }

        normalizeHeading(value) {
          return String(value || '')
            .toLowerCase()
            .replace(/&amp;/g, '&')
            .replace(/[^a-z0-9]+/g, ' ')
            .trim();
        }

        headingsMatch(sectionHeading, tabLabel) {
          const section = this.normalizeHeading(sectionHeading);
          const label = this.normalizeHeading(tabLabel);
          if (!section || !label) return false;
          if (section === label) return true;
          if (section.includes(label) || label.includes(section)) return true;
          if (label.includes('shipping') && section.includes('shipping')) return true;
          if (label.includes('return') && section.includes('return')) return true;
          if (label.includes('spec') && section.includes('spec')) return true;
          if (label.includes('material') && (section.includes('material') || section.includes('metal'))) return true;
          if (label.includes('custom') && section.includes('custom')) return true;
          if (label.includes('faq') && section.includes('faq')) return true;
          if (label.includes('warrant') && section.includes('warrant')) return true;
          return false;
        }

        hydrateFromDescription() {
          const descriptionPanel = this.querySelector('[data-detail-panel="description"]');
          if (!descriptionPanel) return;
          const content = descriptionPanel.querySelector('.astra-details__content');
          if (!content) return;
          const headings = [...content.querySelectorAll('h2')];
          if (headings.length === 0) return;

          const tablist = this.querySelector('[role="tablist"]');
          const container = this.querySelector('.astra-container');
          const claimed = new Set();

          headings.forEach((heading, index) => {
            const title = heading.textContent.trim();
            if (!title) return;

            const nodes = [];
            let node = heading.nextSibling;
            const nextHeading = headings[index + 1] || null;
            while (node && node !== nextHeading) {
              const current = node;
              node = node.nextSibling;
              nodes.push(current);
            }

            const body = document.createElement('div');
            nodes.forEach((item) => body.appendChild(item));
            heading.remove();

            const existingTab = [...this.querySelectorAll('[data-detail-tab]')].find((tab) => {
              const panelId = tab.dataset.detailTab;
              if (claimed.has(panelId)) return false;
              if (panelId === 'description') return false;
              return this.headingsMatch(title, tab.textContent);
            });

            let panel;
            let tab = existingTab;

            if (tab) {
              panel = this.querySelector(`[data-detail-panel="${tab.dataset.detailTab}"]`);
              claimed.add(tab.dataset.detailTab);
            } else {
              const id = `split-${this.normalizeHeading(title).replace(/\s+/g, '-') || index}`;
              tab = document.createElement('button');
              tab.type = 'button';
              tab.setAttribute('role', 'tab');
              tab.id = `DetailTab-${id}`;
              tab.dataset.detailTab = id;
              tab.setAttribute('aria-controls', `DetailPanel-${id}`);
              tab.setAttribute('aria-selected', 'false');
              tab.tabIndex = -1;
              tab.textContent = title;
              tablist.appendChild(tab);

              panel = document.createElement('div');
              panel.id = `DetailPanel-${id}`;
              panel.dataset.detailPanel = id;
              panel.innerHTML = `<details><summary></summary><div class="astra-details__content rte"></div></details>`;
              panel.querySelector('summary').textContent = title;
              container.appendChild(panel);
              claimed.add(id);
            }

            if (!panel) return;

            let details = panel.querySelector('details');
            if (!details) {
              details = document.createElement('details');
              details.innerHTML = `<summary></summary><div class="astra-details__content rte"></div>`;
              panel.appendChild(details);
            }
            const summary = details.querySelector('summary');
            if (summary) summary.textContent = title;
            let target = details.querySelector('.astra-details__content');
            if (!target) {
              target = document.createElement('div');
              target.className = 'astra-details__content rte';
              details.appendChild(target);
            }
            target.innerHTML = body.innerHTML;
            panel.dataset.hasContent = target.textContent.trim() ? 'true' : 'false';
          });

          const remaining = content.innerHTML.trim();
          descriptionPanel.dataset.hasContent = remaining ? 'true' : 'false';
          if (!remaining) {
            const details = descriptionPanel.querySelector('details');
            if (details) details.remove();
          }
        }

        render() {
          const tabbed = this.media.matches && this.dataset.layout === 'tabs';
          this.classList.toggle('is-tabbed', tabbed);
          this.querySelector('[role="tablist"]').hidden = !tabbed;
          this.panels.forEach((panel) => {
            const tab = this.tabs.find((item) => item.dataset.detailTab === panel.dataset.detailPanel);
            const hasContent = panel.dataset.hasContent === 'true';
            const selected = panel.dataset.detailPanel === this.active;
            if (tab) {
              tab.hidden = !hasContent;
              tab.setAttribute('aria-selected', String(selected && hasContent));
              tab.tabIndex = selected && hasContent ? 0 : -1;
            }
            panel.hidden = tabbed ? !(selected && hasContent) : !hasContent;
            if (tabbed && hasContent && tab) {
              panel.setAttribute('role', 'tabpanel');
              panel.setAttribute('aria-labelledby', tab.id);
              panel.tabIndex = 0;
            } else {
              panel.removeAttribute('role');
              panel.removeAttribute('aria-labelledby');
              panel.removeAttribute('tabindex');
            }
            const details = panel.querySelector('details');
            if (details) details.open = tabbed || selected;
          });

          const visibleTabs = this.tabs.filter((tab) => !tab.hidden);
          if (visibleTabs.length && !visibleTabs.some((tab) => tab.dataset.detailTab === this.active)) {
            this.active = visibleTabs[0].dataset.detailTab;
            this.render();
          }
        }

        disconnectedCallback() {
          this.controller?.abort();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('astra-recommendations')) {
    customElements.define('astra-recommendations', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.loaded === 'true') return;
        this.controller = new AbortController();
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            if (entries.some(entry => entry.isIntersecting)) { this.observer.disconnect(); this.load(); }
          }, { rootMargin: '300px' });
          this.observer.observe(this);
        } else this.load();
      }
      async load() {
        const controller = this.controller;
        try {
          const response = await fetch(this.dataset.url, { signal: controller.signal });
          if (!response.ok) throw new Error('Recommendations unavailable');
          const document = new DOMParser().parseFromString(await response.text(), 'text/html');
          const content = document.querySelector('[data-product-recommendations] .astra-recommendations__inner');
          if (!this.isConnected || controller.signal.aborted) return;
          this.dataset.loaded = 'true';
          if (content) {
            this.replaceChildren(content);
            this.dispatchEvent(new CustomEvent('astra:cards:rendered', { bubbles: true }));
          } else this.hidden = true;
        } catch (error) { if (!controller.signal.aborted && this.isConnected) this.hidden = true; }
      }
      disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    function initProduct(root) {
    if (!root || root.dataset.astraBound === '1') return;
    root.dataset.astraBound = '1';

    root.addEventListener('shopify:block:select', function (event) {
      var block = event.target.closest('.astra-product__block');
      if (!block || !root.contains(block)) return;
      block.querySelectorAll('details.astra-product__accordion').forEach(function (details) {
        details.open = true;
      });
    });

    var variantsEl = root.querySelector('[data-astra-product-variants]');
    var variants = [];
    try {
      variants = JSON.parse(variantsEl.textContent);
    } catch (e) {
      variants = [];
    }

    var form = root.querySelector('[data-astra-product-form]');
    var variantInput = root.querySelector('[data-astra-variant-id]');
    var optionSets = Array.prototype.slice.call(root.querySelectorAll('[data-astra-option]'));
    var atc = root.querySelector('[data-astra-atc]');
    var atcLabel = root.querySelector('[data-astra-atc-label]');
    var atcAdding = root.querySelector('[data-astra-atc-adding]');
    var atcAdded = root.querySelector('[data-astra-atc-added]');
    var priceWrap = root.querySelector('[data-astra-price]');
    var saveBadge = root.querySelector('[data-astra-save-badge]');
    var soldBadge = root.querySelector('[data-astra-soldout-badge]');
    var stockEl = root.querySelector('[data-astra-stock]');
    var skuEl = root.querySelector('[data-astra-sku]');
    var skuValue = root.querySelector('[data-astra-sku-value]');
    var sticky = root.querySelector('[data-astra-sticky-atc]');
    var stickyPrice = root.querySelector('[data-astra-sticky-price]');
    var stickySubmit = root.querySelector('[data-astra-sticky-submit]');
    var qtyInput = root.querySelector('[data-astra-qty-input]');
    var mediaNodes = Array.prototype.slice.call(root.querySelectorAll('.astra-product__media'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-astra-thumb]'));
    var mediaList = root.querySelector('[data-astra-media-list]');

    root.querySelectorAll('.astra-product__media iframe').forEach(function (frame) {
      try {
        var videoUrl = new URL(frame.src);
        if (/(^|\.)youtube(?:-nocookie)?\.com$/.test(videoUrl.hostname)) {
          if (videoUrl.searchParams.get('origin') !== window.location.origin) {
            videoUrl.searchParams.set('origin', window.location.origin);
            frame.src = videoUrl.href;
          }
        }
      } catch (error) {}
    });

    var strings = {
      addToCart: (atc && atc.getAttribute('data-label-available')) || 'Add to cart',
      soldOut: (atc && atc.getAttribute('data-label-soldout')) || 'Sold out',
      saveTemplate: (saveBadge && saveBadge.getAttribute('data-save-template')) || 'Save __PERCENT__%'
    };

    function routesRoot() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }

    function stepMedia(delta) {
      var index = mediaNodes.findIndex(function (node) { return node.classList.contains('is-active'); });
      var next = (Math.max(0, index) + delta + mediaNodes.length) % mediaNodes.length;
      if (mediaNodes[next]) setMedia(mediaNodes[next].getAttribute('data-media-id'));
    }
    root.querySelectorAll('[data-astra-media-step]').forEach(function (button) {
      button.addEventListener('click', function () { stepMedia(Number(button.dataset.astraMediaStep)); });
    });
    var touchStart;
    if (mediaList) {
      mediaList.addEventListener('touchstart', function (event) {
        touchStart = null;
        if (event.target.closest('video, iframe, model-viewer, button')) return;
        if (event.touches.length === 1) touchStart = { x: event.touches[0].clientX, y: event.touches[0].clientY };
      }, { passive: true });
      mediaList.addEventListener('touchend', function (event) {
        if (!touchStart || !event.changedTouches.length) return;
        var dx = event.changedTouches[0].clientX - touchStart.x;
        var dy = event.changedTouches[0].clientY - touchStart.y;
        touchStart = null;
        if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) * 1.5) stepMedia(dx < 0 ? 1 : -1);
      }, { passive: true });
      mediaList.addEventListener('touchcancel', function () { touchStart = null; });
    }
    function setMedia(mediaId) {
      if (!mediaId) return;
      var id = String(mediaId);
      if (!mediaNodes.some(function (node) { return node.getAttribute('data-media-id') === id; })) return;
      mediaNodes.forEach(function (node) {
        var active = node.getAttribute('data-media-id') === id;
        node.classList.toggle('is-active', active);
        node.setAttribute('aria-hidden', active ? 'false' : 'true');
        if (!active) {
          node.querySelectorAll('video').forEach(function (video) { video.pause(); });
          node.querySelectorAll('model-viewer').forEach(function (model) { if (model.pause) model.pause(); });
          node.querySelectorAll('iframe').forEach(function (frame) {
            try {
              var origin = new URL(frame.src).origin;
              if (/(^|\.)youtube(?:-nocookie)?\.com$/.test(new URL(frame.src).hostname)) frame.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'pauseVideo', args: [] }), origin);
              if (new URL(frame.src).hostname === 'player.vimeo.com') frame.contentWindow.postMessage(JSON.stringify({ method: 'pause' }), origin);
            } catch (error) {}
          });
        }
        if (active) {
          var counter = root.querySelector('[data-astra-media-counter]');
          if (counter) counter.textContent = (mediaNodes.indexOf(node) + 1) + ' / ' + mediaNodes.length;
        }
      });
      thumbs.forEach(function (thumb) {
        var active = thumb.getAttribute('data-media-id') === id;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    function setAtcState(state) {
      if (!atc) return;
      atc.classList.remove('is-loading', 'is-success');
      if (atcLabel) atcLabel.hidden = false;
      if (atcAdding) atcAdding.hidden = true;
      if (atcAdded) atcAdded.hidden = true;
      if (state === 'loading') {
        atc.classList.add('is-loading');
        if (atcLabel) atcLabel.hidden = true;
        if (atcAdding) atcAdding.hidden = false;
      }
      if (state === 'success') {
        atc.classList.add('is-success');
        if (atcLabel) atcLabel.hidden = true;
        if (atcAdded) atcAdded.hidden = false;
      }
    }

    function updateUI(variant) {
      if (!variant) return;
      if (variantInput) {
        variantInput.value = variant.id;
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      updateCheckoutAvailability();
      root.dispatchEvent(new CustomEvent('astra:variant-change', { bubbles: true, detail: { variant: variant, sectionId: root.dataset.sectionId } }));



      if (saveBadge) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          var percent = Math.round(
            ((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price
          );
          saveBadge.textContent = strings.saveTemplate.replace('__PERCENT__', String(percent));
          saveBadge.hidden = false;
        } else {
          saveBadge.hidden = true;
        }
      }

      if (soldBadge) soldBadge.hidden = !!variant.available;
      if (stockEl) stockEl.hidden = !variant.available;

      if (skuEl && skuValue) {
        if (variant.sku) {
          skuValue.textContent = variant.sku;
          skuEl.hidden = false;
        } else {
          skuEl.hidden = true;
        }
      }

      if (atc) {
        atc.disabled = submitting || !variant.available;
        if (atcLabel) {
          atcLabel.textContent = variant.available
            ? strings.addToCart + ' — ' + variant.price_money
            : strings.soldOut;
        }
      }

      var restock = root.querySelector('[data-astra-back-in-stock]');
      if (restock) { restock.hidden = !!variant.available; restock.dataset.variantId = variant.id; }
      if (stickyPrice) stickyPrice.textContent = variant.price_money;
      var stickyLabel = root.querySelector('[data-astra-sticky-label]');
      if (stickyLabel) stickyLabel.textContent = variant.available ? strings.addToCart : strings.soldOut;
      if (stickySubmit) stickySubmit.disabled = submitting || !variant.available;

      if (variant.featured_media_id) setMedia(variant.featured_media_id);


    }

    var selectionRequest;
    var initialOptionIds = optionSets.map(function (set) { return set.dataset.selectedId; });
    function syncFromSelection() {
      if (variants[0]) updateUI(variants[0]);
    }
    async function selectOption(set, control) {
      if (submitting) { if (control.tagName === 'SELECT') control.value = set.dataset.selectedId; return; }
      if (selectionRequest) selectionRequest.abort();
      selectionRequest = new AbortController();
      var selectedId = control.tagName === 'SELECT' ? control.value : control.dataset.optionValueId;
      set.dataset.selectedId = selectedId;
      var optionIds = optionSets.map(function (option) { return option.dataset.selectedId; });
      var url = new URL(root.dataset.productUrl, window.location.origin);
      url.searchParams.set('option_values', optionIds.join(','));
      var publicUrl = new URL(url);
      url.searchParams.set('section_id', root.dataset.sectionId);
      root.setAttribute('aria-busy', 'true');
      if (atc) atc.disabled = true;
      if (stickySubmit) stickySubmit.disabled = true;
      var checkout = root.querySelector('[data-astra-dynamic-checkout]');
      if (checkout) checkout.inert = true;
      try {
        var response = await fetch(url, { signal: selectionRequest.signal });
        if (!response.ok) throw new Error('Variant update failed');
        var html = new DOMParser().parseFromString(await response.text(), 'text/html');
        var replacement = html.querySelector('[data-astra-product]');
        if (!replacement || replacement.dataset.sectionId !== root.dataset.sectionId) throw new Error('Missing product section');
        var savedFields = Array.from(root.querySelectorAll('[name^="properties["], [name="quantity"]')).map(function (input) { return { name: input.name, value: input.value }; });
        if (root.astraCleanup) root.astraCleanup();
        root.replaceWith(replacement);
        savedFields.forEach(function (saved) {
          replacement.querySelectorAll('[name]').forEach(function (input) {
            if (input.name !== saved.name) return;
            if (input.name === 'quantity') {
              var min = Number(input.min) || 1;
              var step = Number(input.step) || 1;
              var value = min + Math.max(0, Math.floor((Number(saved.value) - min) / step)) * step;
              input.value = String(input.max ? Math.min(Number(input.max), value) : value);
            } else input.value = saved.value;
          });
        });
        initProduct(replacement);
        var focusSet = replacement.querySelector('[data-option-index="' + set.dataset.optionIndex + '"]');
        var focusTarget = focusSet && (focusSet.querySelector('select') || Array.from(focusSet.querySelectorAll('[data-option-value-id]')).find(function (button) { return button.dataset.optionValueId === selectedId; }));
        if (focusTarget) focusTarget.focus({ preventScroll: true });
        var variantField = replacement.querySelector('[data-astra-variant-id]');
        if (variantField && variantField.value) { publicUrl.searchParams.delete('option_values'); publicUrl.searchParams.set('variant', variantField.value); }
        window.history.replaceState({}, '', publicUrl);
        if (window.Shopify && window.Shopify.PaymentButton) window.Shopify.PaymentButton.init();
        replacement.dispatchEvent(new CustomEvent('astra:product-rendered', { bubbles: true }));
      } catch (error) {
        if (error.name === 'AbortError') return;
        optionSets.forEach(function (option, index) {
          option.dataset.selectedId = initialOptionIds[index];
          var select = option.querySelector('select');
          if (select) select.value = initialOptionIds[index];
        });
        root.removeAttribute('aria-busy');
        syncFromSelection();
        var message = root.querySelector('[data-astra-product-message]');
        if (message) { message.textContent = message.dataset.variantError; message.hidden = false; }
      }
    }
    optionSets.forEach(function (set) {
      set.addEventListener('click', function (event) {
        var button = event.target.closest('[data-astra-option-value]');
        if (button) selectOption(set, button);
      });
      set.addEventListener('change', function (event) {
        if (event.target.matches('[data-astra-option-select]')) selectOption(set, event.target);
      });
    });

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        setMedia(thumb.getAttribute('data-media-id'));
      });
    });

    if (mediaList && mediaNodes.length > 1) {
      mediaList.addEventListener('keydown', function (event) {
        if (event.target.closest('video, iframe, model-viewer')) return;
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        event.preventDefault();
        var activeIndex = mediaNodes.findIndex(function (node) {
          return node.classList.contains('is-active');
        });
        if (activeIndex < 0) activeIndex = 0;
        var next =
          event.key === 'ArrowRight'
            ? (activeIndex + 1) % mediaNodes.length
            : (activeIndex - 1 + mediaNodes.length) % mediaNodes.length;
        setMedia(mediaNodes[next].getAttribute('data-media-id'));
      });
    }

    root.querySelectorAll('[data-astra-qty-change]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!qtyInput) return;
        var delta = Number(btn.getAttribute('data-astra-qty-change')) || 0;
        if (delta > 0) qtyInput.stepUp(); else qtyInput.stepDown();
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    function openCartDrawer() {
      var trigger = document.querySelector('[data-astra-drawer-open="cart-drawer"]');
      if (trigger) trigger.click();
    }

    function updateCartCount(count) {
      if (window.AstraTheme && typeof window.AstraTheme.syncCartCount === 'function') {
        window.AstraTheme.syncCartCount(count);
        return;
      }
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = String(count);
        if (count > 0) el.removeAttribute('hidden');
        else el.setAttribute('hidden', '');
      });
    }

    var restockButton = root.querySelector('[data-astra-restock]');
    if (restockButton) restockButton.addEventListener('click', function () {
      var hook = restockButton.closest('[data-astra-back-in-stock]');
      var handled = !root.dispatchEvent(new CustomEvent('astra:back-in-stock', { bubbles: true, cancelable: true, detail: { productId: hook.dataset.productId, variantId: hook.dataset.variantId, trigger: restockButton } }));
      hook.querySelector('[data-astra-restock-message]').hidden = handled;
    });
    function productFormValid() {
      return form && Array.from(form.elements).every(function (control) { return !control.willValidate || control.validity.valid; });
    }
    function updateCheckoutAvailability() {
      var checkout = root.querySelector('[data-astra-dynamic-checkout]');
      if (!checkout) return;
      var available = variants[0] && variants[0].available;
      var valid = productFormValid();
      var blocked = !available || !valid || submitting || root.getAttribute('aria-busy') === 'true';
      checkout.hidden = blocked;
      checkout.inert = blocked;
      var hint = root.querySelector('[data-astra-checkout-hint]');
      if (hint) hint.hidden = !available || valid;
    }
    root.addEventListener('input', updateCheckoutAvailability);
    root.addEventListener('change', updateCheckoutAvailability);
    root.addEventListener('click', function (event) {
      if (!event.target.closest('[data-astra-dynamic-checkout]')) return;
      if (!productFormValid() || submitting || root.getAttribute('aria-busy') === 'true') {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (form) form.reportValidity();
        updateCheckoutAvailability();
      }
    }, true);
    function updateSubtotal() {
      var subtotal = root.querySelector('[data-astra-subtotal]');
      if (!subtotal || !variants[0] || !qtyInput) return;
      try { subtotal.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: root.dataset.currency }).format(variants[0].price * (Number(qtyInput.value) || 1) / 100); } catch (error) { subtotal.textContent = variants[0].price_money; }
    }
    if (qtyInput) { qtyInput.addEventListener('change', updateSubtotal); qtyInput.addEventListener('input', updateSubtotal); }
    updateSubtotal();
    var submitting = false;
    if (form) {
      form.addEventListener('submit', async function (event) {
        event.preventDefault();
        if (submitting || !variantInput || !atc || atc.disabled || !form.reportValidity()) return;
        submitting = true;
        updateCheckoutAvailability();
        atc.disabled = true;
        if (stickySubmit) stickySubmit.disabled = true;
        form.setAttribute('aria-busy', 'true');
        setAtcState('loading');
        var message = root.querySelector('[data-astra-product-message]');
        if (message) message.hidden = true;
        var cartFallback = root.querySelector('[data-astra-cart-fallback]');
        if (cartFallback) cartFallback.hidden = true;
        var added = false;
        try {
          var response = await fetch(routesRoot() + 'cart/add.js', {
            method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form)
          });
          var result = await response.json();
          if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : message.dataset.error);
          added = true;
          setAtcState('success');
          if (message) { message.textContent = message.dataset.added; message.hidden = false; }
          var cartResponse = await fetch(routesRoot() + 'cart.js', { headers: { Accept: 'application/json' } });
          if (!cartResponse.ok) throw new Error('Cart refresh failed');
          updateCartCount((await cartResponse.json()).item_count);
          if (window.AstraTheme && typeof window.AstraTheme.refreshCartDrawer === 'function') await window.AstraTheme.refreshCartDrawer();
          openCartDrawer();
        } catch (error) {
          if (message) {
            message.textContent = added ? message.dataset.refreshError : error instanceof TypeError ? message.dataset.error : error.message || message.dataset.error;
            var cartFallback = root.querySelector('[data-astra-cart-fallback]');
            if (cartFallback) cartFallback.hidden = false;
            message.hidden = false;
          }
        } finally {
          submitting = false;
          form.removeAttribute('aria-busy');
          setAtcState('idle');
          var selectedVariant = variants[0];
          atc.disabled = !selectedVariant || !selectedVariant.available;
          if (stickySubmit) stickySubmit.disabled = atc.disabled;
          updateCheckoutAvailability();
        }
      });
    }

    if (stickySubmit && form) {
      stickySubmit.addEventListener('click', function () {
        if (stickySubmit.disabled) return;
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      });
    }

    var mobileBarObserver;
    if (sticky) {
      var mobileBar = document.querySelector('.astra-mobile-bar');
      if (mobileBar) {
        var updateStickyOffset = function () { sticky.style.setProperty('--product-bottom-offset', mobileBar.getBoundingClientRect().height + 'px'); };
        updateStickyOffset();
        if ('ResizeObserver' in window) { mobileBarObserver = new ResizeObserver(updateStickyOffset); mobileBarObserver.observe(mobileBar); }
      }
    }
    if (sticky && atc && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting || entry.boundingClientRect.bottom > 0) {
              sticky.classList.remove('is-visible');
              sticky.setAttribute('aria-hidden', 'true');
              sticky.inert = true;
            } else {
              sticky.classList.add('is-visible');
              sticky.setAttribute('aria-hidden', 'false');
              sticky.inert = false;
            }
          });
        },
        { threshold: 0 }
      );
      observer.observe(atc);
    }

    syncFromSelection();
    root.astraCleanup = function () { if (observer) observer.disconnect(); if (mobileBarObserver) mobileBarObserver.disconnect(); if (selectionRequest) selectionRequest.abort(); };
    }
    document.querySelectorAll('[data-astra-product]').forEach(initProduct);
    document.addEventListener('shopify:section:load', function (event) {
      event.target.querySelectorAll('[data-astra-product]').forEach(initProduct);
    });
    document.addEventListener('shopify:section:unload', function (event) {
      event.target.querySelectorAll('[data-astra-product]').forEach(function (root) {
        if (root.astraCleanup) root.astraCleanup();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
